module.exports = __webpack_public_path__ + "media/images/common/menu_bag_ov-3cbf35750ca25797ac012cd98ceae1ba.gif";